import request from "@/utils/request";  //导入封装请求的js文件

export function Download(params) {
    return request({
        url: "/memberApi/download/download",  //接口路径
        method: "get",  //接口方法
        params,//接口参数
        timeout: 20000000,  //超时时间
        responseType: "blob"  //返回的数据类型
    });
}

//主页获取文件详细信息
export function getFileLibrary(params) {
    return request({
        url: "/memberApi/download/getLibrary",  //接口路径
        method: "get",  //接口方法
        params  //接口参数
    });
}


export function getDownloadTest(params) {
    return request({
        url: "/common/chunk/download",
        method: "post",
        data: params,
        responseType: "blob",
        timeout: 5000000,
    })
}


export function getDownloadStream(params) {
    return request({
        url: "/common/chunk/downloadStream",
        method: "post",
        data: params,
        responseType: "blob",
        timeout: 5000000,
    })
}

export function saveDownLoadUser(params) {
    return request({
        url: "/memberApi/download/downLoadUser",
        method: "post",
        data: params,
    })
}